import { render, staticRenderFns } from "./WebRTCStatistics.vue?vue&type=template&id=3cdaf370&scoped=true"
import script from "./WebRTCStatistics.vue?vue&type=script&lang=js"
export * from "./WebRTCStatistics.vue?vue&type=script&lang=js"
import style0 from "./WebRTCStatistics.vue?vue&type=style&index=0&id=3cdaf370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdaf370",
  null
  
)

export default component.exports